import { useEffect } from "react";

export const APP_TITLE = "qcom_scrape";

/**
 * Set the browser tab title for as long as the calling component is mounted,
 * restoring the previous title on unmount. Parts are ordered most-specific
 * first so the tab still reads usefully once the browser truncates it:
 * `useDocumentTitle(["30995", "Stores"])` -> "30995 - Stores - qcom_scrape".
 */
export function useDocumentTitle(parts: string | string[]): void {
  const list = (Array.isArray(parts) ? parts : [parts]).filter(Boolean);
  // key on content so a fresh array identity each render doesn't thrash the effect
  const key = JSON.stringify(list);
  useEffect(() => {
    const previous = document.title;
    document.title = [...(JSON.parse(key) as string[]), APP_TITLE].join(" - ");
    return () => {
      document.title = previous;
    };
  }, [key]);
}
